import {User} from '@iw-shop/user/models/user';
import {Customer} from '@iw-shop/customer/models/customer';

export class MappedCustomer extends Customer {
    selected?: boolean = false;

    constructor(data: Customer) {
        super(
            data.id,
            data.email,
            data.addresses,
            data.dateCreated,
            data.lastUpdate
        );
        Object.assign(this, data);
    }
}

export class MappedCustomerFactory {
    static create(data: MappedCustomer): MappedCustomer {
        return new MappedCustomer(
            data
        );
    }
}

export interface UserState extends Partial<User> {
    isLoading?: boolean;
    mappedCustomers?: MappedCustomer[]
}

export const initialUserState = (): UserState => {
    return {};
};
